<section class="pt-16 pb-8 px-container">
    <app-breadcrumb-backoffice [items]="[{ label: 'Home', route: '/backoffice/home' }, { label: 'Spettacoli', route: '/backoffice/spettacoli' }]"></app-breadcrumb-backoffice>
    <h1 class="lg:text-4xl text-2xl font-mono text-center uppercase">Spettacoli</h1>
</section>

@if (loading) {
    <app-loading-backoffice [visible]="true"></app-loading-backoffice>
}

@if (!loading) {
<section class="px-container pb-16" #lista>
    <div class="ac-section-head">
        <div>
            <h2>Elenco spettacoli</h2>            
        </div>
        <a class="acc-btn acc-btn-primary" routerLink="/backoffice/spettacoli/add">+ Aggiungi spettacolo</a>
    </div>

    <div class="ac-toolbar sp-toolbar">
        <input type="text" pInputText class="w-full sp-input" placeholder="Cerca spettacolo o compagnia…" [(ngModel)]="search" />
        <div class="sp-date-filters">
            <div class="sp-date-field">
                <label>Dal</label>
                <p-calendar
                    [(ngModel)]="filterDal"
                    dateFormat="dd/mm/yy"
                    [showIcon]="true"
                    [showClear]="true"
                    placeholder="Filtra dal…"
                    appendTo="body"
                    styleClass="w-full sp-calendar"
                ></p-calendar>
            </div>
            <div class="sp-date-field">
                <label>Al</label>
                <p-calendar
                    [(ngModel)]="filterAl"
                    dateFormat="dd/mm/yy"
                    [showIcon]="true"
                    [showClear]="true"
                    placeholder="Filtra al…"
                    appendTo="body"
                    styleClass="w-full sp-calendar"
                ></p-calendar>
            </div>
        </div>
        <div class="ac-pills">
            <button type="button" class="ac-pill" [class.active]="soloStagione" (click)="soloStagione = true">Stagione corrente</button>
            <button type="button" class="ac-pill" [class.active]="!soloStagione" (click)="soloStagione = false">Tutti</button>
        </div>
    </div>

    <div class="ac-section-head mt-2 mb-2" style="border:0;padding:0;margin-bottom:0.5rem">
        <span class="ac-meta">{{ spettacoliFiltrati.length }} in elenco</span>
    </div>

    <div class="ac-events-list sp-list">
        @for (s of spettacoliFiltrati; track s.id) {
            <div class="ac-event-row sp-row" role="link" tabindex="0" (click)="openModifica(s)" (keydown.enter)="openModifica(s)">
                <div class="ac-event-date text-center">
                    <strong>{{ s.dal | date: 'dd' }}</strong>
                    <span>{{ s.dal | date: 'MMM/yy' | uppercase }}</span>
                </div>
                <div class="sp-thumb">
                    <img #img [src]="(s.img_box + '?type=spettacolo' | image)" alt="" (error)="img.src='../../../../assets/images/Noimage.png'" />
                </div>
                <div class="ac-event-title">
                    {{ s.spettacolo }}
                    <span class="sub">
                        {{ s.compagnia || 'Compagnia da definire' }}
                        @if (!sameDay(s.dal, s.al)) {
                            · fino al {{ s.al | date: 'dd/MM/yyyy' }}
                        }
                    </span>
                </div>
                <div class="sp-actions" (click)="$event.stopPropagation()">
                    <a class="sp-action" pTooltip="Modifica spettacolo" tooltipPosition="top" [routerLink]="'/backoffice/spettacoli/' + s.id" aria-label="Modifica">
                        <i class="bi bi-pencil"></i>
                    </a>
                    <a class="sp-action" pTooltip="Utenti area compagnia" tooltipPosition="top" [routerLink]="'/backoffice/spettacoli/' + s.id + '/utenti-area-compagnia'" aria-label="Utenti">
                        <i class="bi bi-person-square"></i>
                    </a>
                    <a class="sp-action" pTooltip="Gestione area compagnia spettacolo" tooltipPosition="top" [routerLink]="'/backoffice/spettacoli/' + s.id + '/area-compagnia'" aria-label="Area compagnia">
                        <i class="bi bi-ui-checks"></i>
                    </a>
                    <a class="sp-action" pTooltip="Personale area compagnia" tooltipPosition="top" [routerLink]="'/backoffice/spettacoli/' + s.id + '/personale-area-compagnia'" aria-label="Personale">
                        <i class="bi bi-person-badge-fill"></i>
                    </a>
                    <button type="button" class="sp-action danger" pTooltip="Elimina spettacolo" tooltipPosition="top" (click)="onOpenDeleteSpettacolo($event, s)" aria-label="Elimina">
                        <i class="bi bi-trash"></i>
                    </button>
                </div>
                <div class="ac-event-arrow">→</div>
            </div>
        } @empty {
            <div class="ac-empty">Nessuno spettacolo trovato.</div>
        }
    </div>

    <p-confirmPopup #deleteSpettacolo>
        <ng-template pTemplate="headless" let-message>
            <div class="border-round p-3">
                <span class="text-base">{{ message.message }}</span>
                <div class="flex align-items-center gap-2 mt-3">
                    <button type="button" class="acc-btn flex-1" (click)="onDeleteSpettacolo()">Elimina</button>
                    <button type="button" class="acc-btn acc-btn-ghost flex-1" (click)="onAnnullaDeleteSpettacolo()">Annulla</button>
                </div>
            </div>
        </ng-template>
    </p-confirmPopup>
</section>
}
